var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-png",attrs:{"id":("topPng" + _vm.imgModule)}},[_c('canvas',{staticStyle:{"display":"none"},attrs:{"id":("canvas" + _vm.imgModule),"width":"1920"}})])}
var staticRenderFns = []

export { render, staticRenderFns }